import { Link } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { AppointmentDetailsCard } from "@/features/consultations/components";
import { useScheduleContext } from "@/features/consultations/contexts";
import type { ModalProps } from "@/shared/models/legacy-types";
import { Button, CalendarIcon, Dialog } from "@/shared/ui";

export const ScheduleSuccessModal = ({ show, onClose }: ModalProps) => {
  const {
    scheduleDate: { timeSlot },
    provider,
    appointmentToReschedule: rescheduleAppointment,
  } = useScheduleContext();

  if (!timeSlot || !provider) {
    return null;
  }

  return (
    <Dialog.Root open={show} onOpenChange={onClose}>
      <Dialog.Content withCloseButton={false}>
        <Dialog.Header icon={CalendarIcon}>
          <Dialog.Title>
            {rescheduleAppointment
              ? t`Rescheduling successful!`
              : t`Consultation successfully created!`}
          </Dialog.Title>
          <Dialog.Description>
            {t`You can view the details in the Home or Consultations section.`}
          </Dialog.Description>
        </Dialog.Header>

        <AppointmentDetailsCard
          appointment={{ startTime: timeSlot.dateTime, provider }}
        />

        <Dialog.Footer>
          <Button asChild size="lg" onClick={onClose}>
            <Link to={ROUTES.HOME}>{t`Back to Home`}</Link>
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
